import { RoleActions, RoleActionTypes } from './RoleActions';
import { ApplicationDto, Json, PermissionDto, RoleDto } from '@clearing-hub/common';

export interface RoleState {
  roles: Json<string, RoleDto>;
  permissions: Json<number, PermissionDto>;
  applications: Array<ApplicationDto>;
}

export const initialState: RoleState = {
  permissions: {},
  roles: {},
  applications: [],
};

export function roleReducer(state: RoleState = initialState, action: RoleActions):  RoleState {
  switch (action.type) {
    case RoleActionTypes.InitPermissions: {
      const permissions = {};
      const roles = {};
      action.payload.permissions.forEach(p => permissions[p.id] = p);
      action.payload.roles.forEach(r => roles[r.id] = r);
      return {
        ...state,
        permissions: permissions,
        roles: roles,
        applications: action.payload.applications
      };
    }
    case RoleActionTypes.DeleteRole: {
      const { [action.payload]: toDelete, ...rest} = state.roles;
      return {
        ...state,
        roles: rest
      };
    }
    case RoleActionTypes.ChangeApplication: {
      const permissions = {};
      const roles = {};
      action.payload.permissions.forEach(p => permissions[p.id] = p);
      action.payload.roles.forEach(r => roles[r.id] = r);
      return {
        ...state,
        roles: roles,
        permissions: permissions
      };
    }
    case RoleActionTypes.AddRole: {
      return {
        ...state,
        roles: {
          ...state.roles,
          [action.payload.id]: action.payload
        }
      };
    }
  }
  return state;
}

export const initPermissions = (state: RoleState) => state.permissions;
export const initApplications = (state: RoleState) => state.applications;
export const initRoles = (state: RoleState) => state.roles;
